import {
  POWER_QUALITY_MENU,
  MENU_NAMES,
  CONTACT_MENU,
  RESOURCE_MENU,
  SPD_MENU,
  CUSTOMER_SUPPORT_MENU,
} from "const";

// 상단 메뉴 노출 순서: 회사소개 · 제품 · 자료실 · 문의 (+ 장바구니는 Navbar 에서 별도 렌더)
// 「기술 정보」는 개선요청에 따라 상단 메뉴에서 제외. 페이지와 라우팅은 유지된다.
export const MENUS = [
  {
    key: MENU_NAMES.CONTACT.key,
    name: MENU_NAMES.CONTACT.koreanName,
    englishName: MENU_NAMES.CONTACT.englishName,
    children: [
      {
        key: CONTACT_MENU.CEO_GREETING.key,
        name: CONTACT_MENU.CEO_GREETING.koreanName,
        englishName: CONTACT_MENU.CEO_GREETING.name,
        to: `/${MENU_NAMES.CONTACT.key}/${CONTACT_MENU.CEO_GREETING.key}`,
      },
      {
        key: CONTACT_MENU.LOCATION,
        name: CONTACT_MENU.LOCATION.koreanName,
        englishName: CONTACT_MENU.LOCATION.name,
        to: `/${MENU_NAMES.CONTACT.key}/${CONTACT_MENU.LOCATION.key}`,
      },
      {
        key: CONTACT_MENU.HISTORY.key,
        name: CONTACT_MENU.HISTORY.koreanName,
        englishName: CONTACT_MENU.HISTORY.name,
        to: `/${MENU_NAMES.CONTACT.key}/${CONTACT_MENU.HISTORY.key}`,
      },
      {
        key: CONTACT_MENU.CUSTOMERS.key,
        name: CONTACT_MENU.CUSTOMERS.koreanName,
        englishName: CONTACT_MENU.CUSTOMERS.name,
        to: `/${MENU_NAMES.CONTACT.key}/${CONTACT_MENU.CUSTOMERS.key}`,
      },
      {
        key: CONTACT_MENU.NEWS.key,
        name: CONTACT_MENU.NEWS.koreanName,
        englishName: CONTACT_MENU.NEWS.name,
        to: `/${MENU_NAMES.CONTACT.key}/${CONTACT_MENU.NEWS.key}`,
      },
      {
        key: CONTACT_MENU.ABOUT_COMPANY.key,
        name: CONTACT_MENU.ABOUT_COMPANY.koreanName,
        englishName: CONTACT_MENU.ABOUT_COMPANY.name,
        to: `/${MENU_NAMES.CONTACT.key}/${CONTACT_MENU.ABOUT_COMPANY.key}`,
      },
      {
        key: CONTACT_MENU.VIDEOS.key,
        name: CONTACT_MENU.VIDEOS.koreanName,
        englishName: CONTACT_MENU.VIDEOS.name,
        to: `/${MENU_NAMES.CONTACT.key}/${CONTACT_MENU.VIDEOS.key}`,
      },
      {
        key: CONTACT_MENU.ORGANIZATION.key,
        name: CONTACT_MENU.ORGANIZATION.koreanName,
        englishName: CONTACT_MENU.ORGANIZATION.name,
        to: `/${MENU_NAMES.CONTACT.key}/${CONTACT_MENU.ORGANIZATION.key}`,
      },
    ],
  },
  {
    key: MENU_NAMES.PRODUCTS.key,
    name: MENU_NAMES.PRODUCTS.koreanName,
    englishName: MENU_NAMES.PRODUCTS.englishName,
    children: [
      {
        key: SPD_MENU.SPD.key,
        name: SPD_MENU.SPD.koreanName,
        englishName: SPD_MENU.SPD.name,
        to: `/${MENU_NAMES.PRODUCTS.key}/${SPD_MENU.SPD.key}`,
        children: [
          {
            key: SPD_MENU.SPD_FOR_POWER.key,
            name: SPD_MENU.SPD_FOR_POWER.koreanName,
            englishName: SPD_MENU.SPD_FOR_POWER.name,
            img: SPD_MENU.SPD_FOR_POWER.img,
            children: [
              {
                key: SPD_MENU.SG_SERIES.key,
                name: SPD_MENU.SG_SERIES.koreanName,
                englishName: SPD_MENU.SG_SERIES.name,
                img: SPD_MENU.SG_SERIES.img,
                to: `/${MENU_NAMES.PRODUCTS.key}/${SPD_MENU.SPD.key}/${SPD_MENU.SPD_FOR_POWER.key}/${SPD_MENU.SG_SERIES.key}`,
              },
              {
                key: SPD_MENU.R_SERIES.key,
                name: SPD_MENU.R_SERIES.koreanName,
                englishName: SPD_MENU.R_SERIES.name,
                img: SPD_MENU.R_SERIES.img,
                to: `/${MENU_NAMES.PRODUCTS.key}/${SPD_MENU.SPD.key}/${SPD_MENU.SPD_FOR_POWER.key}/${SPD_MENU.R_SERIES.key}`,
              },
              {
                key: SPD_MENU.SB_SERIES.key,
                name: SPD_MENU.SB_SERIES.koreanName,
                englishName: SPD_MENU.SB_SERIES.name,
                img: SPD_MENU.SB_SERIES.img,
                to: `/${MENU_NAMES.PRODUCTS.key}/${SPD_MENU.SPD.key}/${SPD_MENU.SPD_FOR_POWER.key}/${SPD_MENU.SB_SERIES.key}`,
              },
              {
                key: SPD_MENU.PS_SERIES.key,
                name: SPD_MENU.PS_SERIES.koreanName,
                englishName: SPD_MENU.PS_SERIES.name,
                img: SPD_MENU.PS_SERIES.img,
                to: `/${MENU_NAMES.PRODUCTS.key}/${SPD_MENU.SPD.key}/${SPD_MENU.SPD_FOR_POWER.key}/${SPD_MENU.PS_SERIES.key}`,
              },
              {
                key: SPD_MENU.PS_DC_SERIES.key,
                name: SPD_MENU.PS_DC_SERIES.koreanName,
                englishName: SPD_MENU.PS_DC_SERIES.name,
                img: SPD_MENU.PS_DC_SERIES.img,
                to: `/${MENU_NAMES.PRODUCTS.key}/${SPD_MENU.SPD.key}/${SPD_MENU.SPD_FOR_POWER.key}/${SPD_MENU.PS_DC_SERIES.key}`,
              },
            ],
          },
          {
            key: SPD_MENU.SPD_EXTERNAL_DISCONNECTOR.key,
            name: SPD_MENU.SPD_EXTERNAL_DISCONNECTOR.koreanName,
            englishName: SPD_MENU.SPD_EXTERNAL_DISCONNECTOR.name,
            img: SPD_MENU.SPD_EXTERNAL_DISCONNECTOR.img,
            to: `/${MENU_NAMES.PRODUCTS.key}/${SPD_MENU.SPD.key}/${SPD_MENU.SPD_EXTERNAL_DISCONNECTOR.key}`,
          },
          {
            key: SPD_MENU.SPD_FOR_COMMUNICATION.key,
            name: SPD_MENU.SPD_FOR_COMMUNICATION.koreanName,
            englishName: SPD_MENU.SPD_FOR_COMMUNICATION.name,
            to: `/${MENU_NAMES.PRODUCTS.key}/${SPD_MENU.SPD.key}/${SPD_MENU.SPD_FOR_COMMUNICATION.key}`,
          },
          {
            key: SPD_MENU.SPD_EXTRA.key,
            name: SPD_MENU.SPD_EXTRA.koreanName,
            englishName: SPD_MENU.SPD_EXTRA.name,
            to: `/${MENU_NAMES.PRODUCTS.key}/${SPD_MENU.SPD.key}/${SPD_MENU.SPD_EXTRA.key}`,
          },
        ],
      },

      {
        key: POWER_QUALITY_MENU.HARMONIC_REDUCTION_SOLUTION.key,
        name: POWER_QUALITY_MENU.HARMONIC_REDUCTION_SOLUTION.koreanName,
        englishName: POWER_QUALITY_MENU.HARMONIC_REDUCTION_SOLUTION.name,
        img: POWER_QUALITY_MENU.HARMONIC_REDUCTION_SOLUTION.img,
        to: `/${MENU_NAMES.PRODUCTS.key}/${POWER_QUALITY_MENU.POWER_QUALITY.key}/${POWER_QUALITY_MENU.HARMONIC_REDUCTION_SOLUTION.key}`,
        children: [
          {
            key: POWER_QUALITY_MENU.ACTIVE_HARMONIC_FILTER.key,
            name: POWER_QUALITY_MENU.ACTIVE_HARMONIC_FILTER.koreanName,
            englishName: POWER_QUALITY_MENU.ACTIVE_HARMONIC_FILTER.name,
            img: POWER_QUALITY_MENU.ACTIVE_HARMONIC_FILTER.img,
            to: `/${MENU_NAMES.PRODUCTS.key}/${POWER_QUALITY_MENU.POWER_QUALITY.key}/${POWER_QUALITY_MENU.HARMONIC_REDUCTION_SOLUTION.key}/${POWER_QUALITY_MENU.ACTIVE_HARMONIC_FILTER.key}`,
          },
          {
            key: POWER_QUALITY_MENU.ZERO_SEQUENCE_HARMONIC_FILTER.key,
            name: POWER_QUALITY_MENU.ZERO_SEQUENCE_HARMONIC_FILTER.koreanName,
            englishName: POWER_QUALITY_MENU.ZERO_SEQUENCE_HARMONIC_FILTER.name,
            img: POWER_QUALITY_MENU.ZERO_SEQUENCE_HARMONIC_FILTER.img,
            to: `/${MENU_NAMES.PRODUCTS.key}/${POWER_QUALITY_MENU.POWER_QUALITY.key}/${POWER_QUALITY_MENU.HARMONIC_REDUCTION_SOLUTION.key}/${POWER_QUALITY_MENU.ZERO_SEQUENCE_HARMONIC_FILTER.key}`,
          },
        ],
      },

      {
        key: POWER_QUALITY_MENU.REACTIVE_POWER_IMPROVEMENT_SOLUTION.key,
        name: POWER_QUALITY_MENU.REACTIVE_POWER_IMPROVEMENT_SOLUTION.koreanName,
        englishName: POWER_QUALITY_MENU.REACTIVE_POWER_IMPROVEMENT_SOLUTION.name,
        img: POWER_QUALITY_MENU.REACTIVE_POWER_IMPROVEMENT_SOLUTION.img,
        to: `/${MENU_NAMES.PRODUCTS.key}/${POWER_QUALITY_MENU.POWER_QUALITY.key}/${POWER_QUALITY_MENU.REACTIVE_POWER_IMPROVEMENT_SOLUTION.key}`,
        children: [
          {
            key: POWER_QUALITY_MENU.STATIC_VAR_GENERATOR.key,
            name: POWER_QUALITY_MENU.STATIC_VAR_GENERATOR.koreanName,
            englishName: POWER_QUALITY_MENU.STATIC_VAR_GENERATOR.name,
            img: POWER_QUALITY_MENU.STATIC_VAR_GENERATOR.img,
            children: [
              {
                key: POWER_QUALITY_MENU.PSVG_SERIES.key,
                name: POWER_QUALITY_MENU.PSVG_SERIES.koreanName,
                englishName: POWER_QUALITY_MENU.PSVG_SERIES.name,
                img: POWER_QUALITY_MENU.PSVG_SERIES.img,
                to: `/${MENU_NAMES.PRODUCTS.key}/${POWER_QUALITY_MENU.POWER_QUALITY.key}/${POWER_QUALITY_MENU.REACTIVE_POWER_IMPROVEMENT_SOLUTION.key}/${POWER_QUALITY_MENU.STATIC_VAR_GENERATOR.key}/${POWER_QUALITY_MENU.PSVG_SERIES.key}`,
              },
              {
                key: POWER_QUALITY_MENU.PSTA_SERIES.key,
                name: POWER_QUALITY_MENU.PSTA_SERIES.koreanName,
                englishName: POWER_QUALITY_MENU.PSTA_SERIES.name,
                img: POWER_QUALITY_MENU.PSTA_SERIES.img,
                to: `/${MENU_NAMES.PRODUCTS.key}/${POWER_QUALITY_MENU.POWER_QUALITY.key}/${POWER_QUALITY_MENU.REACTIVE_POWER_IMPROVEMENT_SOLUTION.key}/${POWER_QUALITY_MENU.STATIC_VAR_GENERATOR.key}/${POWER_QUALITY_MENU.PSTA_SERIES.key}`,
              },
            ],
          },
          {
            key: POWER_QUALITY_MENU.STATIC_VAR_COMPENSATOR.key,
            name: POWER_QUALITY_MENU.STATIC_VAR_COMPENSATOR.koreanName,
            englishName: POWER_QUALITY_MENU.STATIC_VAR_COMPENSATOR.name,
            img: POWER_QUALITY_MENU.STATIC_VAR_COMPENSATOR.img,
            to: `/${MENU_NAMES.PRODUCTS.key}/${POWER_QUALITY_MENU.POWER_QUALITY.key}/${POWER_QUALITY_MENU.REACTIVE_POWER_IMPROVEMENT_SOLUTION.key}/${POWER_QUALITY_MENU.STATIC_VAR_COMPENSATOR.key}`,
          },
        ],
      },

      {
        key: POWER_QUALITY_MENU.NOISE_REDUCTION_SOLUTION.key,
        name: POWER_QUALITY_MENU.NOISE_REDUCTION_SOLUTION.koreanName,
        englishName: POWER_QUALITY_MENU.NOISE_REDUCTION_SOLUTION.name,
        img: POWER_QUALITY_MENU.NOISE_REDUCTION_SOLUTION.img,
        children: [
          {
            key: POWER_QUALITY_MENU.NOISE_FILTER.key,
            name: POWER_QUALITY_MENU.NOISE_FILTER.koreanName,
            englishName: POWER_QUALITY_MENU.NOISE_FILTER.name,
            img: POWER_QUALITY_MENU.NOISE_FILTER.img,
            to: `/${MENU_NAMES.PRODUCTS.key}/${POWER_QUALITY_MENU.POWER_QUALITY.key}/${POWER_QUALITY_MENU.NOISE_REDUCTION_SOLUTION.key}/${POWER_QUALITY_MENU.NOISE_FILTER.key}`,
          },
          {
            key: POWER_QUALITY_MENU.NOISE_CUT_TRANSFORMER.key,
            name: POWER_QUALITY_MENU.NOISE_CUT_TRANSFORMER.koreanName,
            englishName: POWER_QUALITY_MENU.NOISE_CUT_TRANSFORMER.name,
            img: POWER_QUALITY_MENU.NOISE_CUT_TRANSFORMER.img,
            to: `/${MENU_NAMES.PRODUCTS.key}/${POWER_QUALITY_MENU.POWER_QUALITY.key}/${POWER_QUALITY_MENU.NOISE_REDUCTION_SOLUTION.key}/${POWER_QUALITY_MENU.NOISE_CUT_TRANSFORMER.key}`,
          },
        ],
      },
    ],
  },
  {
    key: MENU_NAMES.RESOURCES.key,
    name: MENU_NAMES.RESOURCES.koreanName,
    englishName: MENU_NAMES.RESOURCES.englishName,
    children: [
      {
        key: RESOURCE_MENU.CATALOGS.key,
        name: RESOURCE_MENU.CATALOGS.koreanName,
        englishName: RESOURCE_MENU.CATALOGS.name,
        to: `/${MENU_NAMES.RESOURCES.key}/${RESOURCE_MENU.CATALOGS.key}`,
      },
      {
        key: RESOURCE_MENU.CERTIFICATE.key,
        name: RESOURCE_MENU.CERTIFICATE.koreanName,
        englishName: RESOURCE_MENU.CERTIFICATE.name,
        to: `/${MENU_NAMES.RESOURCES.key}/${RESOURCE_MENU.CERTIFICATE.key}`,
      },
      {
        key: RESOURCE_MENU.PRE_QUALIFICATIONS.key,
        name: RESOURCE_MENU.PRE_QUALIFICATIONS.koreanName,
        englishName: RESOURCE_MENU.PRE_QUALIFICATIONS.name,
        to: `/${MENU_NAMES.RESOURCES.key}/${RESOURCE_MENU.PRE_QUALIFICATIONS.key}`,
      },
    ],
  },
  {
    key: MENU_NAMES.CUSTOMER_SUPPORT.key,
    name: MENU_NAMES.CUSTOMER_SUPPORT.koreanName,
    englishName: MENU_NAMES.CUSTOMER_SUPPORT.englishName,
    to: `/${MENU_NAMES.CUSTOMER_SUPPORT.key}/${CUSTOMER_SUPPORT_MENU.INQUIRY.key}`,
  },
];
